import type { Action } from 'state/actions';
import { addOrReplaceKey } from 'state/utils/collection';

import type { FormFieldMetadataStateMap } from '../../../common-form/metaData/fields/fields.model';
import * as actionTypes from '../../addonManagementForm.actionTypes';

export function fieldsReducer(state: FormFieldMetadataStateMap = {}, action: Action): FormFieldMetadataStateMap {
  switch (action.type) {
    case actionTypes.ADDON_MANAGEMENT_FORMS_RECEIVED:
      return Object.fromEntries(action.forms.map(form => [form.negotiationId, form.fieldsMetadata]));
    case actionTypes.ADDON_MANAGEMENT_FORM_ENRICHMENT_RECEIVED:
      return addOrReplaceKey(state, action.formId, action.fieldsMetadata);
    case actionTypes.ADDON_MANAGEMENT_QUOTE_RECEIVED: {
      if (action.quote.status !== 'Quoted') {
        return state;
      }
      return updateFormFields(state, action.formId, {
        TradingPrice: { isHidden: false },
        UpfrontFee: { isReadOnly: true },
        OfferPrice: { isReadOnly: true },
        FixedAmountInPercent: { isReadOnly: true },
      });
    }
    case actionTypes.ADDON_MANAGEMENT_QUOTE_EXPIRED: {
      return updateFormFields(state, action.formId, {
        TradingPrice: { isHidden: true },
        UpfrontFee: { isReadOnly: false },
        OfferPrice: { isReadOnly: false },
        FixedAmountInPercent: { isReadOnly: false },
      });
    }
    default:
      return state;
  }
}

type FormFieldMetadata = {
  isHidden?: boolean;
  isReadOnly?: boolean;
};

function updateFormFields(
  state: FormFieldMetadataStateMap,
  formId: string,
  updatedFields: { [s: string]: FormFieldMetadata },
) {
  const form = state[formId];
  const updatedForm = { ...form };
  for (const [fieldName, fieldUpdates] of Object.entries(updatedFields)) {
    updatedForm[fieldName] = { ...form[fieldName], ...fieldUpdates };
  }
  return { ...state, [formId]: updatedForm };
}
